import * as React from "react";
const SvgFiRrBlenderPhone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-blender-phone_svg__a)">
      <path
        fill="#062147"
        d="M21.187 17.18 23.96 3.493A2.997 2.997 0 0 0 21 0H11C9.346 0 8 1.346 8 3v14.127A4.006 4.006 0 0 0 5 21c0 1.654 1.346 3 3 3h13c1.654 0 3-1.346 3-3a4.005 4.005 0 0 0-2.813-3.82M11 2h10c.298 0 .57.125.763.354a.97.97 0 0 1 .23.776L19.182 17H10v-2h2a1 1 0 1 0 0-2h-2v-2h2a1 1 0 1 0 0-2h-2V7h2a1 1 0 1 0 0-2h-2V3c0-.551.448-1 1-1m10 20H8c-.552 0-1-.449-1-1 0-1.103.897-2 2-2h11c1.103 0 2 .897 2 2 0 .551-.448 1-1 1M4.905 15.947 3.867 16a2.7 2.7 0 0 1-1.906-.804c-2.71-2.711-2.517-9.875 0-12.392A2.69 2.69 0 0 1 3.867 2l1.038.053C5.51 2.053 6 2.543 6 3.148l-.205 1.56c0 .605-.49 1.095-1.095 1.095l-1.578.148c-.868 1.939-.91 3.968 0 6.099l1.578.148c.605 0 1.095.49 1.095 1.095L6 14.853c0 .605-.49 1.095-1.095 1.095z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-blender-phone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBlenderPhone;
